export default __webpack_public_path__ + "static/media/dashbaord_eye_upcomming.a6c1a9a5.svg";